import _regeneratorRuntime from 'babel-runtime/regenerator';
import _asyncToGenerator from 'babel-runtime/helpers/asyncToGenerator';

import SearchBar from '@/components/SearchV3/index.vue';
import Pagination from '@/components/Pagination/index.vue';
import TableList from '@/components/TableList/index.vue';
import CommonDialog from './components/common-dialog.vue';
import { testAccountList, addTestAccountList, delTestAccountList } from '@/api/advertiser/manage';
import { AdvertiserAccountTypeLabel } from '@/common/permission';
import AdvertiserSelector from '@/components/AllAdvertiserSelector/index.vue';
import searchMixin from '@/mixin/search';
import _ from 'lodash';

export default {
  components: {
    SearchBar: SearchBar,
    Pagination: Pagination,
    TableList: TableList,
    CommonDialog: CommonDialog
  },
  mixins: [searchMixin],
  data: function data() {
    var keyFieldConfig = [{
      value: 'id',
      label: '广告主ID'
    }, {
      value: 'name',
      label: '广告主名称'
    }, {
      value: 'email',
      label: '广告主邮箱'
    }];

    return {
      query: {
        page: 1,
        page_size: 15,
        search_field: 'name',
        keyword: ''
      },
      pagination: {
        total: 0
      },
      listLoading: true,
      keyFieldConfig: keyFieldConfig,
      list: [],
      dialog: {
        visible: false,
        title: '添加测试账号',
        rules: {
          adv_ids: {
            check: function check(value) {
              if (value.length < 1) return false;
              return true;
            }
          }
        }
      },
      dialogQuery: {
        adv_ids: []
      }
    };
  },

  computed: {
    tableColumnConfig: function tableColumnConfig() {
      return [{
        label: '广告主ID',
        prop: 'adv_id',
        width: 100
      }, {
        label: '广告主名称',
        prop: 'adv_name'
      }, {
        label: '广告主邮箱',
        prop: 'adv_email'
      }, {
        label: 'PT账号类型',
        prop: 'mws_account_type',
        params: {
          innerHTML: function innerHTML(_ref) {
            var row = _ref.row;

            return AdvertiserAccountTypeLabel[row.mws_account_type] || '-';
          }
        }
      }, {
        label: 'BD',
        prop: 'bd'
      }, {
        label: 'BD_AM',
        prop: 'bd_am'
      }, {
        label: '标签添加人',
        prop: 'admin_name'
      }, {
        prop: 'action-cell',
        slot: 'action-cell'
      }];
    },
    formItemList: function formItemList() {
      var _this = this;

      var nameKeywordSearchItem = {
        prop: 'keyword',
        type: 'business',
        subtype: 'advertiser-selector',
        params: {
          filterable: true,
          valueKey: 'name',
          clearable: true
        }
      };

      var otherKeywordSearchItem = {
        prop: 'keyword',
        type: 'input',
        params: function params(_ref2) {
          var formValue = _ref2.formValue;

          return {
            disabled: false,
            readonly: false,
            clearable: true,
            style: 'width: 220px;',
            placeholder: formValue.search_field ? '按' + _this.keyFieldConfig.find(function (item) {
              return item.value === formValue.search_field;
            }).label + '搜索' : '请输入搜索内容'
          };
        }
      };
      var keywordItem = this.query.search_field === 'name' ? nameKeywordSearchItem : otherKeywordSearchItem;
      return [{
        prop: 'search_field',
        type: 'select',
        params: {
          clearable: false,
          filterable: true,
          style: 'width: 220px;',
          options: this.keyFieldConfig,
          placeholder: '请选择搜索类型',
          handleChange: function handleChange(val) {
            _this.query.keyword = '';
          }
        }
      }, keywordItem];
    },
    schema: function schema() {
      return {
        type: 'object',
        properties: {
          adv_ids: {
            title: '广告主名称：',
            component: AdvertiserSelector,
            rules: [{
              required: true,
              message: '请输入广告主名称'
            }],
            field: {
              clearable: true,
              multiple: true,
              filterable: true,
              collapseTags: true,
              style: 'width: 300px;',
              placeholder: '请输入广告主名称'
            }
          }
        }
      };
    }
  },

  watch: {
    $route: function $route() {
      this.renderList();
    }
  },

  mounted: function mounted() {
    var _this2 = this;

    return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return _this2.renderList();

            case 2:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this2);
    }))();
  },


  methods: {
    renderList: function renderList() {
      var _this3 = this;

      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        var res;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _this3.listLoading = true;
                _context2.prev = 1;
                _context2.next = 4;
                return testAccountList(_this3.query);

              case 4:
                res = _context2.sent;

                _this3.list = _.get(res, 'data.data.list') || [];
                _this3.pagination.total = _.get(res, 'data.data.total');
                _this3.listLoading = false;
                _context2.next = 13;
                break;

              case 10:
                _context2.prev = 10;
                _context2.t0 = _context2['catch'](1);

                _this3.listLoading = false;

              case 13:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this3, [[1, 10]]);
      }))();
    },
    handleDialogSubmit: function handleDialogSubmit() {
      var _this4 = this;

      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.prev = 0;
                _context3.next = 3;
                return addTestAccountList(_this4.dialogQuery.adv_ids);

              case 3:
                return _context3.abrupt('return', _context3.sent);

              case 6:
                _context3.prev = 6;
                _context3.t0 = _context3['catch'](0);

                console.log(_context3.t0);
                return _context3.abrupt('return', _context3.t0);

              case 10:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this4, [[0, 6]]);
      }))();
    },
    addTestAccount: function addTestAccount() {
      this.dialog.visible = true;
    },
    delTestAccount: function delTestAccount(row) {
      var _this5 = this;

      this.$confirm('删除测试标签后，该账号使用数据会被计入试玩/视频模版相关统计中。', '确定删除测试账号标签吗？', {
        confirmButtonText: '删除',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
        var res;
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.next = 2;
                return delTestAccountList([row.id]);

              case 2:
                res = _context4.sent;

                if (res.data.code === 0) {
                  _this5.$message.success('操作成功');
                  _this5.renderList();
                }

              case 4:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, _this5);
      }))).catch(function () {});
    }
  }
};